export default {
    lang: {
        name: 'Inventory location'
    }
}